import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Checkbox } from '../../../Form';
import { BoxTitle, Box } from '../../../PageTemplate';
import { update } from './utils'; 

import './close.scss';

class Close extends Component {
    constructor(props) {
        super(props);

        this.state = {
            eventID: null,
            eventData: {},
            eventFinised: false,
            eventStarted: false
        }

        this.handleClosedChange = this.handleClosedChange.bind(this);
        this.update = update.bind(this);
    }

    static getDerivedStateFromProps(props, state) {
        const {eventFinised, eventStarted} = props;
        const events = props.events.list;
        const eventID = props.events.currentEventID;
        const newState = {};
        const newStateData = {};

        if(!events || !events[eventID]) return null;
        
        if(eventID && eventID !== state.eventID) newState.eventID = eventID; 
        if(eventFinised && eventFinised !== state.eventFinised) newState.eventFinised = eventFinised;
        if(eventStarted && eventStarted !== state.eventStarted) newState.eventStarted = eventStarted;
        
        const {closed} = events[eventID];
        if(closed !== undefined && closed !== state.eventData.closed) newStateData.closed = closed;

        if(Object.keys(newStateData).length > 0) newState.eventData = newStateData;
        if(Object.keys(newState).length > 0) return newState;

        return null;
    }

    handleClosedChange(event) {
        const data = {...this.state.eventData};
        data.closed = !data.closed;

        this.setState({eventData: data}, this.update);
    }

    render() {
        const {eventData, eventFinised, eventStarted} = this.state;
        const closed = eventData.closed || "";

        return (
            <Box id="closeEventSettings" col="1">
                <BoxTitle icon="faHeartbeat">
                    סטטוס:&nbsp;
                    <div className={`normal-weight ${eventStarted || eventFinised ? 'hide': ''}`}>
                        טרם נפתח
                    </div>
                    <div className={`normal-weight ${!eventFinised ? 'hide': ''}`}>
                        הסתיים
                    </div>
                    <div className={`checkbox-in-title ${!eventStarted || eventFinised ? 'hide': ''}`}>
                        <Checkbox
                            name="closed"
                            isChecked={!closed}
                            disabled={eventFinised}
                            onChange={this.handleClosedChange}
                            label={` ${closed ? 'סגור זמנית' : 'פתוח'}`}
                            labelSide="left"
                        />
                    </div>
                </BoxTitle>
            </Box>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        events: state.eventsReducer
    }
}

const CloseWithRedux = connect(mapStateToProps)(Close);

export {CloseWithRedux as Close};


// WEBPACK FOOTER //
// ./src/components/EventPage/settings/event/Close.jsx